module.exports = __webpack_public_path__ + "img/response-time.f8110d8e.svg";